import { render, staticRenderFns } from "./market-summary.page.vue?vue&type=template&id=d9435aa6&scoped=true"
import script from "./market-summary.page.vue?vue&type=script&lang=ts"
export * from "./market-summary.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9435aa6",
  null
  
)

export default component.exports